<div class="row">
  <div class="col">
    <div id="jitsi-iframe">
      <div class="meeting-logo"></div>
    </div>
  </div>
</div>

